import React, { useContext, useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Navbar,
  NavDropdown,
  Nav,
  Button,
  Offcanvas,
  Form,
  Modal
} from "react-bootstrap";
import { isEmpty } from "lodash";
import { useForm } from "react-hook-form";
import io from "socket.io-client";
import AuthContext from "../context/AuthContext";
import { Helmet } from "react-helmet";
import notifySound from "../assets/newAudio.wav";
import { BiSupport } from "react-icons/bi";
import {
  Link,
  NavLink,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import helpers from "../utils/helpers";
import download from "../assets/images/download-icon.png";
import upload from "../assets/images/upload.png";
import constant from "../utils/constants";
const Header = () => {
  const [socket, setSocket] = useState(null);
  const { register, handleSubmit } = useForm({ mode: "onChange" });
  const location = useLocation();
  const { count, bellSound } = useContext(AuthContext);
  const parmas = useParams();
  const navigate = useNavigate();
  const current_url = location.pathname.split("/")[1];
  let {
    user,
    logoutUser,
    user_coins,
    setUserCoins,
    getCoins,
    isRefereshLoader,
    setRefereshLoader,
  } = useContext(AuthContext);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleFormSubmit = (form_data = {}) => {
    document.documentElement.style.setProperty("--primary", "#b36c3d");
  };
  useEffect(() => {
    const newSocket = io(
      `${process.env.REACT_APP_API_BASE_URL}?token=${user._id ? user._id : 112233
      }`,
      {
        transports: ["websocket"],
      }
    );
    const coinListener = (message) => {
      setUserCoins(message.results.totalCoins);
    };
    const forceLogout = (message) => {
      const uniqueId = localStorage.getItem("uniqueId");
      if (uniqueId !== message.results.uniqueId) {
        logoutUser();
      }
    };
    newSocket.emit("getCoins", { user_id: user._id });
    newSocket.on("listenGetCoin", coinListener);
    newSocket.on("listenForceLogout", forceLogout);
    setSocket(newSocket);
    return () => newSocket.close();
  }, [setSocket]);
  const [expanded, setExpanded] = useState(false);
  const [check, setCheck] = useState(
    parmas?.id && parmas.user_type ? true : false
  );

  // const MINUTE_MS = 10000;
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     getCoins();
  //   }, MINUTE_MS);

  //   return () => clearInterval(interval);
  // }, []);
  useEffect(() => {
    if (bellSound) {
      let interval = setInterval(() => {
        const clickSound = new Audio(notifySound);
        clickSound.play().catch(function (error) {
          console.log(
            "Chrome cannot play sound without user interaction first"
          );
        });
      }, 1500);
      return () => {
        clearInterval(interval);
      };
    }
  }, [bellSound]);
   const [displayPopUp, setDisplayPopUp] = useState(false);
  const closePopUp = () => {
    localStorage.setItem("seenPopUp", true);

    setDisplayPopUp(false);
  };
  useEffect(() => {
    let returningUser = localStorage.getItem("seenPopUp");
    setDisplayPopUp(!returningUser);
  }, []);
  return (
    <div>
      <header>
        <Helmet>
          <meta name="viewport" content="width=device-width, initial-scale=0" />
        </Helmet>
        <div className="top-header">
          <Container fluid>
            <Row className="align-items-center">
              <Col sm={4}>
                <div className="logo">
                  <a href="/" className="d-inline-block">
                    <img
                      src="./assets/images/logo.png"
                      alt=""
                      style={{ maxWidth: `45%` }}
                    />
                  </a>
                </div>
              </Col>
              {!isEmpty(user) ? (
                <Col sm={8}>
                  <div className="text-sm-end text-center top-header-owner">
                    <ul className="list-unstyled mb-0">
                      {((user?.userType == "sub_admin" &&
                        user?.platformType == "B2C") ||
                        (user?.userType == "agent" &&
                          user?.platformType == "B2B")) && (
                          <>
                            <li
                              onClick={() => navigate("/wallet-deposit")}
                              className="header-count cursor-pointer heartBeat "
                              style={{ cursor: "pointer" }}
                            >
                              <img
                                style={{
                                  width: "23px",
                                  height: "23px",
                                  filter: `invert(1)`
                                }}
                                src={download}
                              />
                              <span>{count?.depositRequests || 0}</span>
                            </li>
                            <li
                              onClick={() => navigate("/wallet-withdrawal")}
                              className="header-count cursor-pointer heartBeat "
                              style={{ cursor: "pointer" }}
                            >
                              <img
                                style={{
                                  width: "23px",
                                  height: "23px",
                                  filter: `invert(1)`
                                }}
                                src={upload}
                              />
                              <span>{count?.withdrawalRequests || 0}</span>
                            </li>{" "}
                            {/* <li
                            onClick={() => navigate("/customer-support")}
                            className="header-count cursor-pointer"
                            style={{ cursor: "pointer" }}
                          >
                            <BiSupport color="black" size={20} />
                            <span>{count?.totalUnreadCount || 0}</span>
                          </li> */}
                          </>
                        )}
                      <li>
                        <a href="#" className="text-decoration-none">
                          <span>
                            {user?.userType == "super_admin"
                              ? "Mother Panel"
                              : constant?.user_status[user?.userType || ""]}
                          </span>{" "}</a>
                        <strong><i

                          class="fa fa-user"
                          aria-hidden="true"
                        ></i> {user?.username || ""}</strong>
                      </li>
                      {isRefereshLoader ? (
                        <li>
                          <p className="loading-bar" id="menuRefreshLoading">
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                          </p>
                        </li>
                      ) : (
                        <>
                          <li>
                            <a href="#" className="text-decoration-none">
                              <span>Main</span>{" "}
                              <strong>
                                <i

                                  class="fa fa-money-bill"
                                  aria-hidden="true"
                                ></i>  BDT {helpers.currencyFormat(user_coins)}
                              </strong>
                            </a>

                          </li>
                          <li>
                            <a
                              href="#"
                              // className="btn"
                              onClick={() => getCoins()}
                            >
                              <span>
                                <i className="fas fa-redo-alt"></i>
                              </span>
                            </a>
                          </li>
                          <li>
                            {isEmpty(user) ? (
                              <Link to="/login">
                                Login <i className="fa-solid fa-right-from-bracket"></i>
                              </Link>
                            ) : (
                              <a
                                style={{ cursor: "pointer", color: '#000' }}
                                as={NavLink}
                                to="#"
                                onClick={logoutUser}
                              >
                                <i

                                  class="fas fa-sign-out-alt"
                                  aria-hidden="true"
                                ></i>   Logout{" "}

                              </a>
                            )}
                          </li>
                        </>


                      )}
                    </ul>
                  </div>
                </Col>
              ) : null}
            </Row>
          </Container>
        </div>

        <div className="main-header">
          <Container fluid>
            <Navbar expand="xl" expanded={expanded}>
              <Navbar.Toggle
                aria-controls="basic-navbar-nav"
                onClick={() => setExpanded(expanded ? false : "expanded")}
              />
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto">
                  {(user?.userType == "super_admin" || user?.userType == "agent" ||
                    (user?.userType == "sub_admin" &&
                      user?.platformType == "B2C")) && (
                      <Nav.Link
                        as={NavLink}
                        onClick={() => setExpanded(false)}
                        to="/dashboard"
                        className={current_url === "dashboard" ? "active1" : ""}
                      >
                        Board
                      </Nav.Link>
                    )}
                  <Nav.Link
                    as={NavLink}
                    to="/"
                    onClick={() => setExpanded(false)}
                    className={
                      current_url === "" ||
                        current_url === "account-summary" ||
                        current_url === "betting-history" ||
                        current_url === "activity-log" ||
                        current_url === "betting-profit-loss" ||
                        current_url === "transaction-history" ||
                        current_url === "transaction-history-2" ||
                        current_url === parmas?.id
                        ? "active1"
                        : ""
                    }
                  >
                    {" "}
                    Client List
                  </Nav.Link>
                  <Nav.Link
                    as={NavLink}
                    onClick={() => setExpanded(false)}
                    to="/my-account-summary"
                    className={
                      current_url === "my-account-summary" ||
                        current_url === "my-account-statement" ||
                        current_url === "my-profile" ||
                        current_url === "my-activity-log"
                        ? "active1"
                        : ""
                    }
                  >
                    Profile
                  </Nav.Link>
                  {(user?.userType == "owner" ||
                  user?.userType == "sub_owner" ||
                    user?.userType == "super_admin" ||
                    user?.userType == "admin" ||
                    user?.platformType == "B2B") && (
                      <NavDropdown title="Report Room" id="basic-nav-dropdown">
                        <NavDropdown.Item
                      onClick={() => setExpanded(false)}
                      as={NavLink}
                      to="/AllAprofitByDownline"
                    >
                      {" "}
                      All Profit/Loss Report by Downline
                    </NavDropdown.Item>
                        {/* <NavDropdown.Item
                          onClick={() => setExpanded(false)}
                          as={NavLink}
                          to="/AprofitDownline"
                        >
                          {" "}
                          Profit/Loss by Downline
                        </NavDropdown.Item> */}
                          <NavDropdown.Item
                      onClick={() => setExpanded(false)}
                      as={NavLink}
                      to="/MatchWiseProfitLoss"
                    >
                      Match Profit Loss
                    </NavDropdown.Item>
                        {/* <NavDropdown.Item
                          onClick={() => setExpanded(false)}
                          as={NavLink}
                          to="/AprofitMarket"
                        >
                          Profit/Loss Report by Market
                        </NavDropdown.Item> */}
                        <NavDropdown.Item
                          onClick={() => setExpanded(false)}
                          as={NavLink}
                          to="/AprofitPlayer"
                        >
                          Profit/Loss Report by Player
                        </NavDropdown.Item>
                        {/* <NavDropdown.Item
                          onClick={() => setExpanded(false)}
                          as={NavLink}
                          to="/Adownlinesportspl"
                        >
                          Profit/Loss Sports Wise
                        </NavDropdown.Item> */}

                        <NavDropdown.Item
                          onClick={() => setExpanded(false)}
                          as={NavLink}
                          to="/ACdownlinesportspl"
                        >
                          All Casino Profit/Loss
                        </NavDropdown.Item>
                        {/* <NavDropdown.Item
                          onClick={() => setExpanded(false)}
                          as={NavLink}
                          to="/AprofitCasino"
                        >
                          Casino Profit/Loss Report by Date
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          onClick={() => setExpanded(false)}
                          as={NavLink}
                          to="/ACasinoprofitAndLossDownlineNew"
                        >
                          Casino P/L by Downline
                        </NavDropdown.Item> */}

                        <NavDropdown.Item
                          onClick={() => setExpanded(false)}
                          as={NavLink}
                          to="/report/awc"
                        >
                          {" "}
                          Profit/Loss AWC Casino Bets
                        </NavDropdown.Item>
                      </NavDropdown>)}
                  { ( user?.userType === "sub_admin" &&  user?.platformType === "B2C"  ) || user?.userType == "super_admin" || (user?.platformType == "B2B" && user?.userType == "agent") ? (
                    <Nav.Link
                      as={NavLink}
                      onClick={() => setExpanded(false)}
                      to="/banner-list"
                      className={current_url === "banner-list" ? "active1" : ""}
                    >
                      Banner
                    </Nav.Link>
                  ) : (
                    ""
                  )}
                  <Nav.Link
                    as={NavLink}
                    onClick={() => setExpanded(false)}
                    to="/Betlist"
                    className={current_url === "Betlist" ? "active1" : ""}
                  >
                    BetList
                  </Nav.Link>
                  <Nav.Link
                    as={NavLink}
                    onClick={() => setExpanded(false)}
                    to="/BetListLive"
                    className={current_url === "BetListLive" ? "active1" : ""}
                  >
                    BetListLive
                  </Nav.Link>
                  <Nav.Link
                    as={NavLink}
                    to="/RiskManagement"
                    onClick={() => setExpanded(false)}
                    className={
                      current_url === "RiskManagement" ? "active1" : ""
                    }
                  >
                    Risk Check
                  </Nav.Link>
                  {(
                  (
                    user?.userType === "owner" ||
                     user?.userType === "sub_owner" ||
                    user?.userType === "super_admin" ||
                    user?.userType === "admin" ||
                    user?.platformType === "B2B"
                  ) ||
                  (
                    user?.userType === "sub_admin" &&
                    user?.platformType === "B2C"
                  )
                ) && (
                      <NavDropdown title="Banking" id="basic-nav-dropdown">
                        {/*  ( */}
                        <NavDropdown.Item
                          onClick={() => setExpanded(false)}
                          as={NavLink}
                          to="/banking"
                          className={current_url === "banking" ? "active1" : ""}
                        >
                          {" "}
                          D/W
                        </NavDropdown.Item>
                        {/* )} */}
                        {(
                          user?.userType == "super_admin" ||
                          user?.userType == "admin" ||
                          user?.platformType == "B2B") || (user?.userType == "sub_admin" &&
                            user?.platformType == "B2C") && (
                            <NavDropdown.Item
                              onClick={() => setExpanded(false)}
                              as={NavLink}
                              to="/settlement"
                              className={current_url === "settlement" ? "active1" : ""}
                            >
                              {" "}
                              Settlement
                            </NavDropdown.Item>
                          )}
                        {((user?.userType == "agent" &&
                          user?.platformType == "B2B") ||
                          (user?.userType == "sub_admin" &&
                            user?.platformType == "B2C")) && (
                            <NavDropdown.Item
                              as={NavLink}
                              onClick={() => setExpanded(false)}
                              to="/banks"
                              className={current_url === "banks" ? "active1" : ""}
                            >
                              Set Banks
                            </NavDropdown.Item>
                          )}
                      </NavDropdown>
                    )}


                  {user?.userType == "sub_admin" &&
                    user?.platformType == "B2C" && (
                      <NavDropdown title="Commission" id="basic-nav-dropdown">
                        <NavDropdown.Item
                          onClick={() => setExpanded(false)}
                          as={NavLink}
                          to="/Withdraw_request"
                        >
                          {" "}
                          Agent WD Request
                        </NavDropdown.Item>

                        <NavDropdown.Item
                          onClick={() => setExpanded(false)}
                          as={NavLink}
                          to="/commission-report"
                        >
                          {" "}
                          Commission Report
                        </NavDropdown.Item>

                        <NavDropdown.Item
                          onClick={() => setExpanded(false)}
                          as={NavLink}
                          to="/agent-withdraw-history"
                        >
                          {" "}
                          Agent WD History
                        </NavDropdown.Item>
                      </NavDropdown>
                    )}
                  {user?.userType == "super_agent" &&
                    user?.platformType == "B2C" && (
                      <Nav.Link
                        as={NavLink}
                        onClick={() => setExpanded(false)}
                        to="/commission-report"
                        className={
                          current_url === "commission-report" ? "active1" : ""
                        }
                      >
                        Commission Report
                      </Nav.Link>
                    )}

                  {user?.userType == "agent" && user?.platformType == "B2C" && (
                    <Nav.Link
                      as={NavLink}
                      onClick={() => setExpanded(false)}
                      to="/commission-report"
                      className={
                        current_url === "commission-report" ? "active1" : ""
                      }
                    >
                      Commission Report
                    </Nav.Link>
                  )}
                  {((user?.userType == "agent" &&
                    user?.platformType == "B2B") ||
                    (user?.userType == "sub_admin" &&
                      user?.platformType == "B2C")) && (
                      <NavDropdown
                        title="D/W Management"
                        id="basic-nav-dropdown"
                      >
                        <NavDropdown.Item
                          onClick={() => setExpanded(false)}
                          as={NavLink}
                          to="/wallet-deposit"
                        >
                          {" "}
                          Pending Deposit
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          onClick={() => setExpanded(false)}
                          as={NavLink}
                          to="/wallet-withdrawal"
                        >
                          {" "}
                          Pending Withdrawal
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          onClick={() => setExpanded(false)}
                          as={NavLink}
                          to="/deposit-history"
                        >
                          {" "}
                          Deposit History
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          onClick={() => setExpanded(false)}
                          as={NavLink}
                          to="/withdrawal-history"
                        >
                          {" "}
                          Withdrawal History
                        </NavDropdown.Item>
                      </NavDropdown>
                    )}

                  {((user?.userType == "agent" &&
                    user?.platformType == "B2B") ||
                    (user?.userType == "sub_admin" &&
                      user?.platformType == "B2C")) && (
                      <NavDropdown title="SMS" id="basic-nav-dropdown">

                        <NavDropdown.Item
                          as={NavLink}
                          onClick={() => setExpanded(false)}
                          to="/sms"
                          className={current_url === "sms" ? "active1" : ""}
                        >
                          {" "}
                          Bkash SMS
                        </NavDropdown.Item>

                        <NavDropdown.Item
                          as={NavLink}
                          onClick={() => setExpanded(false)}
                          to="/nagad-sms"
                          className={current_url === "nagad-sms" ? "active1" : ""}
                        >
                          {" "}
                          Nagad SMS
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          as={NavLink}
                          onClick={() => setExpanded(false)}
                          to="/rocket-sms"
                          className={current_url === "rocket-sms" ? "active1" : ""}
                        >
                          {" "}
                          Rocket SMS
                        </NavDropdown.Item>


                      </NavDropdown>)}

                  {(user?.userType == "agent" && user?.platformType == "B2B") || (user?.userType == "sub_admin" &&  user?.platformType == "B2C")  ? (
                        <>

                          <Nav.Link
                            as={NavLink}
                            onClick={() => setExpanded(false)}
                            to="/block-market"
                            className={
                              current_url === "block-market" ? "active1" : ""
                            }
                          >
                            Block Market
                          </Nav.Link>
                        </>
                      ):""}

                  {/* {(user.userType === "owner" ||
                    user?.userType == "super_admin") && (
                    <Nav.Link
                      as={NavLink}
                      onClick={() => setExpanded(false)}
                      to="/sport-setting"
                      className={
                        current_url === "sport-setting" ? "active1" : ""
                      }
                    >
                      Sport Setting
                    </Nav.Link>
                  )} */}
                  {/* {((user?.userType == "agent" &&
                    user?.platformType == "B2B") ||
                    (user?.userType == "sub_admin" &&
                      user?.platformType == "B2C")) && (
                    <Nav.Link
                      as={NavLink}
                      onClick={() => setExpanded(false)}
                      to="/customer-support"
                      className={
                        current_url === "customer-support" ? "active1" : ""
                      }
                    >
                      Customer Support
                    </Nav.Link>
                  )} */}
                {user.userType === "owner" || user?.userType == "super_admin" || user?.userType == "super_admin" ?
                     (
                    <Nav.Link
                      as={NavLink}
                      onClick={() => setExpanded(false)}
                      to="/defaultsetting"
                      className={
                        current_url === "defaultsetting" ? "active1" : ""
                      }
                    >
                      Game Setting
                    </Nav.Link>
                  ):""}
                  {user?.userType !== "super_agent" || user.userType == "owner" || user.userType == "super_admin" || user.userType == "admin" || user?.platformType == "B2B" || (user?.userType == "sub_admin" && user?.platformType == "B2C")  ? (
                    <Nav.Link
                      as={NavLink}
                      to="/general-setting"
                      onClick={() => setExpanded(false)}
                      className={
                        current_url === "general-setting" ||
                          current_url === "active-match" ||
                          current_url === "in-active-match"
                          ? "active1"
                          : ""
                      }
                    >
                      Setting
                    </Nav.Link>) : ""}
                  {user.userType == "owner" || user.userType == "super_admin" || user.userType == "admin" || user?.platformType == "B2B" || (user?.userType == "sub_admin" && user?.platformType == "B2C") ?
                    <Nav.Link
                      as={NavLink}
                      to="/searchuser"
                      onClick={() => setExpanded(false)}
                      className={
                        current_url === "searchuser"

                          ? "active1"
                          : ""
                      }
                    >
                      Find user
                    </Nav.Link> : ""}
                  {
                    user?.userType == "super_admin" && (
                      <Nav.Link
                        as={NavLink}
                        to="/defaultAgent"
                        onClick={() => setExpanded(false)}
                        className={
                          current_url === "defaultAgent"

                            ? "active1"
                            : ""
                        }
                      >
                        Set Agent
                      </Nav.Link>
                    )}
                  {/* {(user.userType === "owner" ||
                    user?.userType == "super_admin") && (
                    <Nav.Link
                      as={NavLink}
                      onClick={() => setExpanded(false)}
                      to="/result"
                      className={current_url === "result" ? "active1" : ""}
                    >
                      Result
                    </Nav.Link>
                  )} */}
                </Nav>
              </Navbar.Collapse>

              <div className="main-header-time-zone">
                <ul className="list-unstyled  mb-0">
                  {/* {(user.userType === "admin" && user.platformType == "B2C") &&
                  <li>
                    Deposit & Support : <span><a href="https://wa.me/+33644657178 " >Whatsapp</a></span>
                  </li>
                  } */}

                </ul>
              </div>
            </Navbar>
          </Container>
        </div>
      </header>

      {/* <Button
        variant="primary"
        onClick={handleShow}
        className="color-picker-btn"
      >
        <i className="fa-solid fa-gear"></i>
      </Button> */}

      <Offcanvas show={show} onHide={handleClose} placement={"end"}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Change Your Theme</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form onSubmit={handleSubmit(handleFormSubmit)}>
            <div className="d-flex align-items-center justify-content-between">
              <div className="text-center">
                <Form.Label for="primary" className="form-label">
                  Primary Color
                </Form.Label>
                <Form.Control
                  type="color"
                  className="form-control-color m-auto"
                  id="primary"
                  value="#3db39e"
                  title="Choose your color"
                  {...register("primary_color", {
                    required: "Please select color",
                  })}
                />
              </div>

              <div className="text-center">
                <Form.Label for="secondary" className="form-label">
                  Secondary Color
                </Form.Label>
                <Form.Control
                  type="color"
                  className="form-control-color m-auto"
                  id="secondary"
                  value="#060316"
                  title="Choose your color"
                  {...register("secondary_color", {
                    required: "Please select color",
                  })}
                />
              </div>
            </div>
            <button className="btn" type="submit">
              Save
            </button>
            <button className="btn" type="button">
              Reset
            </button>
          </Form>
        </Offcanvas.Body>
      </Offcanvas>
      {displayPopUp && (
        <Modal
          centered
          show={true}
          onHide={closePopUp}
          className="anouncement-popup"
          dialogClassName="announcement-modal-dialog"
        >
          <Modal.Header className="announcement-modal-header">
            <Modal.Title className="announcement-modal-title">
              Announcement
            </Modal.Title>

            <button
              type="button"
              className="announcement-close-btn"
              onClick={closePopUp}
              aria-label="Close"
            >
              &times;
            </button>
          </Modal.Header>

          <Modal.Body className="mobile-singup-bonus">
            <img
              src="/assets/images/anouncement.jpeg"
              alt="Announcement"
            />
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
};

export default Header;
